export default __webpack_public_path__ + "static/media/discordapp.7ff7bff2.svg";